/* eslint-disable import/prefer-default-export */
export enum SummaryType {
  All = 'all',
  Current = 'current',
  Custom = 'customDateRange',
}
